import { Injectable, Injector } from '@angular/core';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class IdentityUsersService extends ApiServiceBase {
  constructor(injector: Injector) {
    super(injector);
    this.setBase(API_NAMES.identity);
  }

  setCustomerUserToken(accountId: number) {
    return this.client.get<any>(this._url(`/customer-token/${accountId}`));
  }

  createUser(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  // updateUser(id: string, model: any) {
  //   return this.client.put(this._url(`/${id}`), model);
  // }
  updateUser(id: any, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteUser(id: string) {
    return this.client.delete(this._url(`/${id}`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/users${v}`);
  }
}
